export default "__VITE_ASSET__90b4ff2f__"